/**
 * The watching line the video panel puts in front of a message: which file is playing and where
 * it stood. Shared: the browser writes and draws it, the server keeps it out of a session's title.
 */
const WATCHING = /^\[watching (.+) at (?:(\d+):)?(\d{1,2}):(\d{2})\]\n\n/;

/** `MM:SS`, or `H:MM:SS` once there is an hour to show -- the way a material writes its times. */
export function formatClock(seconds: number): string {
	const total = Math.max(0, Math.floor(seconds));
	const pad = (n: number) => String(n).padStart(2, "0");
	const hours = Math.floor(total / 3600);
	const minutes = Math.floor((total % 3600) / 60);
	const secs = total % 60;
	return hours ? `${hours}:${pad(minutes)}:${pad(secs)}` : `${pad(minutes)}:${pad(secs)}`;
}

export function formatWatching(file: string, seconds: number): string {
	return `[watching ${file.replace(/[\]\r\n]/g, " ")} at ${formatClock(seconds)}]\n\n`;
}

export function parseWatching(text: string): { file: string; seconds: number; rest: string } | null {
	const match = WATCHING.exec(text);
	if (!match) return null;
	const [hours, minutes, secs] = [Number(match[2] ?? 0), Number(match[3]), Number(match[4])];
	if (minutes > 59 || secs > 59) return null;
	return { file: match[1]!, seconds: hours * 3600 + minutes * 60 + secs, rest: text.slice(match[0].length) };
}

/** What goes in front of a message: nothing without a video, or with one that was never played. */
export function watchingPrefix(video: { file: string; seconds: number; played: boolean } | null): string {
	if (!video || (!video.played && video.seconds === 0)) return "";
	return formatWatching(video.file, video.seconds);
}
